// extracted by mini-css-extract-plugin
module.exports = {"game":"game_game__168O9","container-badge":"game_container-badge__1ZujI"};